module.exports = __webpack_public_path__ + "img/app_icon_web.69f45162.png";